export default __webpack_public_path__ + "static/media/am_close.b86aec00.svg";